import { render, staticRenderFns } from "./CertificateView.vue?vue&type=template&id=1c7be32b&scoped=true"
import script from "./CertificateView.vue?vue&type=script&lang=js"
export * from "./CertificateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7be32b",
  null
  
)

export default component.exports